// smtData.js

export const defaultSteps = [
  {
    id: 1,
    title: "Breath Reset",
    description:
      "Box-style breathing to calm the nervous system: inhale 4s, hold 4s, exhale 6s. Repeat slowly and focus on the body.",
    duration: 60,
  },
  {
    id: 2,
    title: "Intention Anchor",
    description:
      "Set a short intention aloud or silently: 'Observe — don't absorb.' Repeat 3–5x and visualize a calm boundary.",
    duration: 45,
  },
  {
    id: 3,
    title: "Micro-boundaries",
    description:
      "Practice neutral responses and tiny disengagements. Visualize a polite social 'mask' you can put on and remove.",
    duration: 40,
  },
  {
    id: 4,
    title: "Curiosity Shift",
    description:
      "Turn judgment into curiosity. Ask one small question and really listen for data. Keep your inner commentary on pause.",
    duration: 120,
  },
  {
    id: 5,
    title: "In-situation Practice",
    description:
      "Short live exposure: enter a real conversation for a brief time (3–5 minutes) and use the tools above.",
    duration: 300,
  },
  {
    id: 6,
    title: "Debrief & Log",
    description:
      "One-line debrief: what triggered you? what worked? Save a short note to build pattern awareness.",
    duration: 60,
  },
];

export const phrases = [
  "We shall see.",
  "Interesting.",
  "That's one way to see it.",
  "I'll think about that.",
  "Hmm.",
  "Thanks for sharing.",
  "Noted.",
  "I understand.",
  "Good point.",
  "I hear you.",
  "That’s valid.",
  "Point taken.",
  "Makes sense.",
  "I’ll consider that.",
  "I see what you mean.",
  "Noted with thanks.",
  "Appreciate the insight.",
  "Understood.",
  "I get it.",
  "Ah, okay.",
  "Right, right.",
  "I see.",
  "Alright then.",
  "Okay.",
  "Interesting perspective.",
  "Thanks for pointing that out.",
  "Got it.",
  "I’ll keep that in mind.",
  "Alright.",
  "Noted, thank you.",
  "I see your point.",
  "Fair enough.",
  "Understood, thanks.",
  "Okay, I hear you.",
  "Ah, I understand now.",
  "Noted, I appreciate it.",
  "I follow you.",
  "That’s clear.",
  "Point understood.",
  "Thanks for clarifying.",
  "I’ll think on that.",
  "I understand your perspective.",
  "Right, I get it now.",
  "I see where you’re coming from.",
  "Makes sense, thanks.",
  "Alright, noted.",
  "Understood completely.",
  "Gotcha.",
  "Yes, I see.",
  "Absolutely.",
  "Thanks for sharing your thoughts.",
  "I understand what you mean.",
  "I hear that.",
  "Alright, I follow.",
  "Okay, that works.",
  "Noted and understood.",
  "Ah, thanks for explaining.",
  "I appreciate your point.",
  "I see your reasoning.",
  "Alright, I understand.",
  "Makes sense.",
  "Okay, I see that now.",
  "Understood, I’ll note that.",
  "Noted, I see.",
  "Ah, got it.",
  "Okay, thanks.",
  "I hear you clearly.",
  "Yes, that makes sense.",
  "I understand clearly now.",
  "Alright, got it.",
  "Understood, thank you.",
  "I follow your point.",
  "Thanks for sharing that.",
  "I see your logic.",
  "Right, understood.",
  "Okay, point taken.",
  "I hear you, thanks.",
  "Understood, I’ll remember that.",
  "Noted, thank you for explaining.",
  "I see, makes sense.",
  "Alright, got it noted.",
  "Okay, I understand now.",
  "Thanks, that’s helpful.",
  "I follow that.",
  "Ah, I see.",
  "Understood completely, thanks.",
  "Noted, I get it.",
  "Alright, understood.",
  "Okay, thanks for that.",
  "I see, point understood.",
  "I hear that clearly.",
  "Noted, I understand.",
  "Makes sense, noted.",
  "Alright, I follow now.",
];
